import React, {PropsWithChildren} from 'react';
import {useTranslation} from 'react-i18next';
import {UserInteractionsAnalytics} from '../../../../incase-domain/analytics';
import UserInteractionCard from './UserInteractionCard';
import SkeletonLoader from '../../../components/common/SkeletonLoader';

interface UserInteractionReportProps {
    userInteractions: UserInteractionsAnalytics | undefined;
    isLoading: boolean;
}

function UserInteraction(props: PropsWithChildren<UserInteractionReportProps>): JSX.Element {
    const {userInteractions, isLoading} = props;
    const {t} = useTranslation();

    return (
        <div>
            <div className="p-presReport__card_title">{t('reportPage.general')}</div>

            <div className="p-presReport__card">
                <div className="b-userInteraction">
                    <SkeletonLoader isLoading={isLoading}>
                        <UserInteractionCard
                            icon="solar:play-bold"
                            title={t('reportPage.userInteractions.noOfTimesStarted')}
                            content={userInteractions?.total || 0}
                        />
                    </SkeletonLoader>
                    <SkeletonLoader isLoading={isLoading}>
                        <UserInteractionCard
                            icon="solar:forbidden-circle-bold"
                            title={t('reportPage.userInteractions.noOfTimesStartedWithNoInteractions')}
                            content={userInteractions?.noInteracts || 0}
                        />
                    </SkeletonLoader>
                    <SkeletonLoader isLoading={isLoading}>
                        <UserInteractionCard
                            icon="solar:user-hand-up-bold"
                            title={t('reportPage.userInteractions.currentActiveUsers')}
                            content={userInteractions?.activeUsers || 0}
                        />
                    </SkeletonLoader>
                    <SkeletonLoader isLoading={isLoading}>
                        <UserInteractionCard
                            icon="solar:clock-square-bold"
                            title={t('reportPage.userInteractions.averageSessionTime')}
                            content={userInteractions?.averageSessionTime || '0'}
                        />
                    </SkeletonLoader>
                </div>
            </div>
        </div>
    );
}

export default UserInteraction;
